import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Booking Core**
 *
 * @exports bs_0
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_211
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            // Home
            let aux = document.documentElement.lang;
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            // BE (../be/rv.xhmtl?lng=es)
            aux = thn.parseUrlParameter('lng');
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_211
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new URL(ctx.baseUrl);
        const validUrl = url.host.match(/yomohotels.bookingcoremini.com/);
        if (validUrl) {
            // https://yomohotels.bookingcoremini.com/be/rv_tarifas.xhtml?lng=es&thn=1&promocode=JHJWKEJ
            url.searchParams.set('lng', '[language]');
            url.searchParams.set('promocode', '');
            url.searchParams.set('thn', '1');
            // export into ctx.new_url
            ctx.newUrl = url.toString();
        }
        else {
            // This is not a valid URL
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_211
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        var $ = window.jQuery;
        var $currSelector = $('.coin');
        if ($currSelector.length
            && !thn.bookingCoreUpdater) {
            thn.bookingCoreUpdater = thn.debounce(function thnBookingCore() {
                // try to refresh the PW data, then hide only if PW data is not set
                if (ctx.widget.refresh() && !ctx.widget.isSet()) {
                    ctx.widget.hide();
                }
            }, 200);
            thn.observeDom($currSelector.get(0), thn.bookingCoreUpdater, {
                childList: true,
                subtree: false,
                characterData: false,
                attributes: false,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom($currSelector.get(0), thn.bookingCoreUpdater);
                delete thn.bookingCoreUpdater;
            });
        }
    };
    /**
       * @memberOf module:bs_211
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // Status: no-rooms
        if ($('#calendarios').length || $('.message error').length || $('#calendars').length) {
            widgetData.noRooms = true;
        }
        else {
            let dates;
            let dateBegin;
            let dateEnd;
            // Dates (Desktop)
            dates = $('.dates p');
            dateBegin = dates.length && (dates[0].textContent.match(/(\d+)\D+(\d+)\D+(\d+)/) || [])[0];
            dateEnd = dates.length > 1 && (dates[1].textContent.match(/(\d+)\D+(\d+)\D+(\d+)/) || [])[0];
            if (dateBegin) {
                widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            if (dateEnd) {
                widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            // Dates (Mobile)
            if (!widgetData.dateBegin || !widgetData.dateEnd) {
                dates = $('.date-info span');
                dateBegin = dates.length && (dates[0].textContent.match(/(\d+)\D+(\d+)\D+(\d+)/) || [])[0];
                dateEnd = dates.length > 1 && (dates[1].textContent.match(/(\d+)\D+(\d+)\D+(\d+)/) || [])[0];
                if (dateBegin) {
                    widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                }
                if (dateEnd) {
                    widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                }
            }
            // Nights
            if (widgetData.dateBegin && widgetData.dateEnd) {
                widgetData.nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
            }
            // Guests, Adults & Children
            const adults = thn.parseNumber(document.querySelector('.rooms_details .pax.adults')?.textContent) || 2;
            const children = thn.parseNumber(document.querySelector('.rooms_details .pax.kids')?.textContent) || 0;
            const roomInfo = {
                adults: adults,
                children: children,
                childrenAges: [],
            };
            for (let i = 1; i <= roomInfo.children; i += 1) {
                roomInfo.childrenAges.push(10);
            }
            widgetData.roomsDispo = [roomInfo];
            // Prices & Currency || No Rooms
            const prices = $('.conv').map(function (key, price) {
                return thn.parseNumber(price.textContent);
            }).toArray();
            if (prices.length) {
                widgetData.price = Math.min(...prices);
                if (widgetData.nights) {
                    widgetData.price /= widgetData.nights;
                }
                else {
                    this.logger.debug('[PW] - Nights not detected. Price is not being divided');
                }
                // Get the currency for the first price available (ex. 51.20 EUR)
                const currSelector = $('.check-room.price sub');
                widgetData.currency = (currSelector.length && currSelector[0].textContent.trim()) || 'EUR';
                widgetData.set = true;
            }
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_211
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        const purchase = window.bcDataLayer?.find((el) => el[1] === 'purchase');
        const bookingDataSet = Object.fromEntries(window._wic);
        if (!$) {
            return widgetData;
        }
        widgetData.bookingId = window.orderRef.split(' ')[0] || thn.objectGet(purchase, 'transaction_id', { first: false }) || bookingDataSet._setRef || '';
        if (window.location.hostname.match(/fenixhotel.bookingcore.mobi/)) { // Dates & Price (Mobile)
            const dates = $('.o-dates-info span');
            widgetData.dateBegin = dates.length && (translateDate(dates[0].textContent, thn.data.language));
            widgetData.dateEnd = dates.length > 1 && (translateDate(dates[1].textContent, thn.data.language));
            widgetData.price = thn.parseNumber($('.o-total-price strong')[0].textContent.split(' ')[2]);
        }
        else { // Dates & Price (Desktop)
            const priceEl = document.querySelector('#book-total span')?.textContent;
            const price = thn.parseNumber(priceEl) || thn.parseNumber(thn.objectGet(purchase, 'value'), { first: false }) || thn.parseNumber(bookingDataSet._setAmount);
            const datesFromDom = document.querySelectorAll('.dates');
            const dateBegin = bookingDataSet._setCheckin?.replace(/-/g, '/') || datesFromDom[0]?.textContent?.match(/\d+/g).join('/').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            const dateEnd = bookingDataSet._setCheckout?.replace(/-/g, '/') || window.checkOutDate || datesFromDom[1]?.textContent?.match(/\d+/g).join('/').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateBegin = dateBegin || $('#breakdown_price td:eq(4)').text().trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = dateEnd || $('#breakdown_price td:eq(5)').text().trim().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.price = price || thn.parseNumber($('.conv').eq(0).text());
        }
        if (window.currencyCode) {
            widgetData.currency = window.currencyCode || bookingDataSet._setCurrency;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_211
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = document.querySelector('#promoAbs')?.innerText.replace(/\n/, '');
        if (promocode) {
            ctx.promocode = promocode;
        }
        else {
            ctx.promocode = '';
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
